function forceInputNumeric(e) {
  const start = e.target.selectionStart;
  const end = e.target.selectionEnd;
  e.target.value = e.target.value.replace(/[^\d\s]/g, '');
  e.target.setSelectionRange(start, end);
}

function forceInputAlphnumeric(e) {
  const start = e.target.selectionStart;
  const end = e.target.selectionEnd;
  e.target.value = e.target.value.replace(/[^a-zA-Z\d\s]/g, '');
  e.target.setSelectionRange(start, end);
}

function forceInputUppercase(e) {
  const start = e.target.selectionStart;
  const end = e.target.selectionEnd;
  e.target.value = e.target.value.toLocaleUpperCase();
  e.target.setSelectionRange(start, end);
}

function forceInputNoSpaces(e) {
  const start = e.target.selectionStart;
  const end = e.target.selectionEnd;
  e.target.value = e.target.value.replace(/\s/g, '');
  e.target.setSelectionRange(start, end);
}

export default {
  registerInputListeners: () => {
    const uppercaseInputs = document.getElementsByClassName('uppercase');
    if (uppercaseInputs) {
      for (let uppercaseInput of uppercaseInputs) {
        uppercaseInput.addEventListener('input', forceInputUppercase);
      }
    }

    const alphanumericInputs =
      document.getElementsByClassName('alphanumericOnly');
    if (alphanumericInputs) {
      for (let alphanumericInput of alphanumericInputs) {
        alphanumericInput.addEventListener('input', forceInputAlphnumeric);
      }
    }

    const numericInputs = document.getElementsByClassName('numericOnly');
    if (numericInputs) {
      for (let numericInput of numericInputs) {
        numericInput.addEventListener('input', forceInputNumeric);
      }
    }

    const noPasteElements = document.getElementsByClassName('noPaste');
    if (noPasteElements) {
      for (let noPasteElement of noPasteElements) {
        noPasteElement.addEventListener('paste', (e) => {
          e.preventDefault();
        });
      }
    }

    const noSpaceElements = document.getElementsByClassName('noSpace');
    if (noSpaceElements) {
      for (let noSpaceElement of noSpaceElements) {
        noSpaceElement.addEventListener('input', forceInputNoSpaces);
      }
    }
  },
};
